var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/message-sent-manager.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2952de4b!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/message-sent-manager.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MessageSentManager.vue
// module id = 1326
// module chunks = 1